import { DefaultError, QueryClient, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { eramanCMSApi } from "~/Services";

export interface DocumentDetailsResponse {
  tid: number;
  name: string;
  field_sign_in_text_en: string;
  field_sign_in_text_malay: string;
  field_sign_in_text_mandarin: string;
  field_sign_in_icon_image: string;
  field_location_text_en?: string;
  field_location_text_malay: string;
  field_location_text_mandarin: string;
  field_location_icon_image: string;
  field_wishlist_text_en: string;
  field_wishlist_text_malay: string;
  field_wishlist_text_mandarin: string;
  field_wishlist_icon_image: string;
  field_created_date?: string;
  field_updated_date?: string;
  field_products_published?: string;
  field_register_en?: string;
  field_register_ms?: string;
  field_register_zh?: string;
  createdAt: string;
  updatedAt: string;
  status: boolean;
}

const fetchAllTopHeaderData = async (): Promise<DocumentDetailsResponse[]> => {
  const response = await eramanCMSApi.get(`/api/get-header-top/all`);
  // console.log("API Response:", response.data); // Full API response
  return response?.data || [];
};

const useAllTopHeaderDocuments = (
  options?: UseQueryOptions<DocumentDetailsResponse[], DefaultError>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse[], DefaultError> => {
  return useQuery<DocumentDetailsResponse[], DefaultError>({
    queryKey: ["allTopHeaderDocuments"],
    queryFn: fetchAllTopHeaderData,
    refetchOnWindowFocus: true,
    staleTime: 0,
    ...options,
  });
};

export { useAllTopHeaderDocuments };
